import { InputType } from "../components/sop/inputPanel";

export const formFields = {
  endpoint: "touristoccupation",
  inputs: [
    {
      name: "occupation",
      label: "Occupation",
      placeholder: "Engineer",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "annual_income",
      label: "Annual Income",
      placeholder: "1000000 INR",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "experience",
      label: "Experience",
      placeholder: "10 years",
      type: InputType.CountedTextInput,
      minLength: 1,
      maxLength: 100,
    },
    {
      name: "additional_details_of_occupation",
      label: "Additional details of Occupation",
      placeholder: "10 years",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
  ],
};

export default formFields;
